export const CUSTOM_FIELDS = "Custom Field"
export const USER_NAMES = "User"
export const SUBSCRIBERS = "Subscriber"
export const CONNECTORS = "Connector"
export const POLARITY_TYPES = "Polarity Type"
export const EXCEL_LABELS = "Excel Label"
export const LABELS = "Label"